import { SceneWrapper } from '~/components';
import { FormikProps, isEmpty, useFormikContext } from '~/modules';
import { CreditSimulationPixKeyConfirmationFormValues } from './schema';
import { ButtonComponent, Input } from './styles';

const CreditSimulationPixKeyConfirmation = () => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
  }: FormikProps<CreditSimulationPixKeyConfirmationFormValues> =
    useFormikContext();

  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="btn-simulation-value"
          onPress={submitForm}
          disabled={
            !isValid || isEmpty(values.CreditSimulationPixKeyConfirmation)
          }
          fullWidth
        >
          AVANÇAR
        </ButtonComponent>
      }
    >
      <Input
        name="CreditSimulationPixKeyConfirmation"
        id="CreditSimulationPixKeyConfirmation"
        value={values.CreditSimulationPixKeyConfirmation}
        onChange={(e) =>
          setFieldValue('CreditSimulationPixKeyConfirmation', e.target.value)
        }
        label="Confirme a chave PIX"
        errors={errors?.CreditSimulationPixKeyConfirmation}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationPixKeyConfirmation;
